module.exports = __webpack_public_path__ + "media/images/lb/715-af4a1c21b103fc1606f5629af48a6371.svg";